const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"EqL__CXmX_nmOpJrKbEmf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["guess-the-price-fe@sentry"]={id:"EqL__CXmX_nmOpJrKbEmf"};
      